{
  "info": "Oplysninger",
  "negative": "Fejl",
  "notice": "Advarsel",
  "positive": "Fuldført"
}
